<!-- <span class="print_dropdown ml-10" ngbDropdown>
    <button class="btn btn-sm btn-round btn-outline-secondary" type="button" id="printMenu" ngbDropdownToggle>
        <i class="fa fa-print fa-fw gray mr-5"></i>Print</button>
    <ul class="right print-rpt" ngbDropdownMenu aria-labelledby="printMenu">
        <li (click)="createPdf()"><i class="fn-global-pdf font-weight-bold fa-fw"></i>Download PDF</li>
        <li (click)="createXLSX()"><i class="fn-global-excel font-weight-bold fa-fw"></i>Download Excel</li>
    </ul>
</span> -->


<!-- #docregion mat-menu-trigger-for -->
<button mat-button [matMenuTriggerFor]="menu" title="Print" class="dropdown-toggle export-data-btn"><i class="fn-global-print  mr-0"></i></button>
<!-- #enddocregion mat-menu-trigger-for -->
<mat-menu #menu="matMenu" panelClass="grid-mat-panel">
    <button mat-menu-item (click)="createPdf()"><i class="fn-global-pdf red font-20 mr-8"></i>Download PDF</button>
    <button mat-menu-item (click)="createXLSX()"><i class="fn-global-excel blue font-20 mr-8"></i>Download Excel</button>
    <button mat-menu-item (click)="createCsv()"><i class="fn-global-excel green font-20 mr-8"></i>Download CSV</button>
</mat-menu>